import _styled from "styled-components";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Link } from "~/features/ui/link";
import { isLinkValid } from "~/features/ui/link/utils";
import { takeFirst } from "~/features/app/utils";
const fragment = graphql(`
  fragment LandingFooterBottomLink on footerBottomLinks_link_BlockType {
    link: baseLink {
      ...Link
    }
  }
`);
export function FooterBottomLink(props: FragmentType<typeof fragment>) {
  const {
    link: _link
  } = useFragment(fragment, props);
  const link = takeFirst(_link);
  if (!isLinkValid(link)) {
    return null;
  }
  return <_StyledLink {...link} />;
}
var _StyledLink = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "footer-bottom-link___StyledLink",
  componentId: "sc-1e31j2c-0"
})({
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "transitionProperty": "opacity",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out",
  "@media (hover: hover)": {
    "&:hover": {
      "opacity": "0.6"
    }
  },
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.016rem",
    "fontWeight": "400"
  }
});